__turbopack_context__.v({
  "block": "styles-module-scss-module__IATevW__block",
  "form": "styles-module-scss-module__IATevW__form",
  "header": "styles-module-scss-module__IATevW__header",
});
